import axios from "axios";
import { clearAuthSession, getAuthToken } from "./auth";
import { localLabelFallback } from "./utils/localLabelFallback";

const baseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL_PROD || process.env.REACT_APP_API_BASE_URL || ""
    : process.env.REACT_APP_API_BASE_URL || "";

const api = axios.create({
  baseURL,
});

// Flipkart browser sessions exist only on the operator's Mac. Keep ordinary
// Scan API traffic on the website backend, but send live Flipkart OTC requests
// to the local bridge that owns the seven dedicated Chrome profiles.
export const localFlipkartApi = axios.create({
  baseURL: "http://127.0.0.1:8766",
  timeout: 120000,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["X-Scan-Auth-Token"] = token;
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `scan_auth_token=${encodeURIComponent(token)}; Path=/; SameSite=Lax; Max-Age=2592000${secure}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => localLabelFallback(response),
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.includes("/api/auth/login")) {
      clearAuthSession();
      if (!window.location.pathname.includes("login")) {
        window.location.href = window.location.pathname.startsWith("/admin")
          ? "/admin/login"
          : "/";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
